import { Alert, Col, FormLabel, InputGroup, Row } from "react-bootstrap";
import { IFieldEditor, IJSTreeNode, IPage } from "../../../../models/Interfaces";
import TreeSelect from "../../../components/common/TreeSelect";
import { useEffect, useRef, useState } from "react";
import { ContentService } from "../../../../services/ContentService";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faTimes } from "@fortawesome/free-solid-svg-icons";
import { TreeItemSort } from "../../../../config/Enums";


const PageSelectEditor = (props: IFieldEditor) => {
  const [ pages, setPages ] = useState<Array<IJSTreeNode>>([]);
  const serviceRef = useRef<ContentService>();

  const onPageSelect = (value: string) => {
    props.onValueChange(props.property.Id, value);
  };

  const clearSelection = (): void => {
    props.onValueChange(props.property.Id, "");
  };

  const getPages = async () : Promise<void> => {
    if (serviceRef.current) {
      const res = await serviceRef.current.getPagesTreeData();

      if (res?.length > 0) {
        setPages(res);
      }
    }
  };

  useEffect(() => {
    if (!serviceRef.current) {
      serviceRef.current = new ContentService();
    }
    getPages();
  }, []);

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      
      { pages.length > 0 ? (
        <div>
          <div>
            <InputGroup>
              <TreeSelect
                typeKey="type"
                valueKey="url"
                displayKey="text"
                items={pages}
                parentKey="parent"
                idKey="id"
                closeText="close pages list"
                openText="select site page..."
                onItemSelect={onPageSelect}
                selectnodetype="page"
                initialValue={props.property.PublishedValue}
                style={{ flexGrow: 1 }}
                rootNodeKeyValue={"#"} 
                closeOnSelect={true}
                popoverTitle="Select Page" 
                hideClear={true}
                triggerClassName="page-selector__trigger"
                sortBy={TreeItemSort.Unsorted}/>
              <InputGroupText className="page-selector__action" title="clear selected page" onClick={clearSelection} style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faTimes} />
              </InputGroupText>
              <InputGroupText className="page-selector__action page-selector__action--last">
                <FontAwesomeIcon icon={faRefresh} style={{cursor: "pointer"}} title="refresh page list..." onClick={getPages} />
              </InputGroupText>
            </InputGroup>
          </div>
          <div>
            <FormLabel className="text-secondary mt-2">Selected url: {props.property.PublishedValue ?? "None"}</FormLabel>
          </div>
        </div>
      ) : (
        <div>
          <Alert variant="info" className="text-center fw-bold">
            <span>No pages to select</span>
          </Alert>
        </div>
      )}
    </>
  );
}

export default PageSelectEditor;
